export class Logger {
    constructor (prefix = '', level='info') {
        this._prefix = prefix
        this._levels = ['debug', 'info', 'warning', 'error', 'fatal']
        this.setLevel(level)
    }

    setLevel (level) {
        var numLevel = this._levels.indexOf(level)
        if (numLevel < 0) {
            throw 'Level "' + level + '" is not a valid level'
        }
        this._level = numLevel
    }

    log(message, level='info') {
        var numLevel = this._levels.indexOf(level)
        if (numLevel < this.level) {
            return
        }
        console.log(this._prefix + ' <' + level + '> ' + message)
    }

    debug (message) { this.log(message, 'debug') }
    info (message) { this.log(message, 'info') }
    warning (message) { this.log(message, 'warning') }
    error (message) { this.log(message, 'error') }
    fatal (message) { this.log(message, 'fatal') }
}


export function changeFavicon(src) {
 //document.head = document.head || document.getElementsByTagName('head')[0];
 var link = document.createElement('link'),
     oldLink = document.getElementById('dynamic-favicon');
 link.id = 'dynamic-favicon';
 link.rel = 'shortcut icon';
 link.href = src;
 if (oldLink) {
  document.head.removeChild(oldLink);
 }
 document.head.appendChild(link);
}


/*
 * This Class contain date conversion helpers
 */
export class OmaDateTime {
    constructor (date=null, time=null){
        /* No date given */
        if (date === null && time === null) {
            this.date = new Date()
        } else if (time !== null && typeof(date) == 'string') {
            this.fromHtmlDateTime(date,time)
        } else if (time === null && typeof(date) == 'number') {
            this.fromTimestamp(date)
        } else if (time === null && typeof(date) == 'string') {
            this.fromPacDateTime(date)
        } else if (time === null && typeof(date) == 'Object') {
            this.fromJsDateTime(date)
        } else {
            throw 'Date format not reconized'
        }
    }

    fromPacDateTime (p) {
        var tab = p.split('m')
        var year = tab[0]
        tab = tab[1]+'m'+tab[2]
        tab = tab.split('j')
        var month = parseInt(tab[0]) - 1
        tab = tab[1].split('h')
        var day = tab[0]
        tab = tab[1].split('mn')
        var hours = tab[0]
        tab = tab[1].split('s')
        var min = tab[0]
        var sec = tab[1]
        this.date =  new Date(year, month, day, hours, min, sec)
        return this
    }

    fromJsDateTime (d) {
        this.date = d
        return this
    }

    /* C’est utc, on veut utc+2 */
    fromTimestamp (t){
        this.date = new Date(t*1000)
        return this
    }

    fromHtmlDateTime (d, t) {
        //dateTab = d.split('-')
        //timeTab = t.split(':')
        //this.date = new Date(dateTab[0], dateTab[1], dateTab[2], timeTab[0], timeTab[1], timeTab[2])
        this.date = new Date(d + ' ' + t)
        return this
    }

    toTimestamp(){
        return this.date / 1000
    }
    toJsDateTime(){
        return this.date
    }
    toPacDateTime(){
        return String(this.date.getFullYear())
            + 'm' + String(this.date.getMonth()+1).padStart(2, '0')
            + 'j' + String(this.date.getDate()).padStart(2, '0')
            + 'h' + String(this.date.getHours()).padStart(2, '0')
            + 'mn'+ String(this.date.getMinutes()).padStart(2, '0')
            + 's' + String(this.date.getSeconds()).padStart(2, '0')
    }
    toHtmlDate(){
        return this.date.getFullYear() +'-'+ String(this.date.getMonth()+1).padStart(2, '0') +'-'+ String(this.date.getDate()).padStart(2, '0')
    }
    toHtmlTime(){
        return String(this.date.getHours()).padStart(2, '0') +':'+ String(this.date.getMinutes()).padStart(2, '0') +':'+ String(this.date.getSeconds()).padStart(2, '0')
    }
    toLocaleDateTime (join) {
        join = join ? join : ' '
        return this.date.toLocaleDateString() + join + this.date.toLocaleTimeString()
    }
    minusDays(number) {
        this.date.setDate(this.date.getDate() - number)
        return this
    }
}


/*
 * This Class connect to a omaWebServer with websockets
 * You create an instance : new OmaWebsocketClient('listen.oma-radio.fr', '2001')
 * It will create a singleton, any other instance you can create with new OmaWebsocketClient() will return the same instance
 * You add a callback that will be called on a channel message with : (new OmaWebsocketClient).handler('12', function(message){console.log(message)}
 * You can add any handler you want but not remove them as this time
 * TODOs:
 * - Authorize handlers removing
 * - Set a handler to all messages (like the debug one
 */
// TODO En cas de coupure des WS, retenter la connexion
export class OmaWebsocketClient {
    constructor (radioHost, wssPort, ssl=true) {
        /* Singleton */
        const instance = this.constructor.instance;
        if (instance) {
            return instance;
        }
        this.constructor.instance = this;

        this._log = new Logger('OmaWS', 'error')

        /* Actual Constructor */
        if (typeof(ssl) == 'string') { /* string to boolean */
            this.ssl = (ssl === 'true')
        } else {
            this.ssl = ssl
        }
        var scheme = this.ssl ? 'wss://' : 'ws://'
        this.host  = scheme + radioHost
        this.port  = wssPort

        this.channelHandlers = {}
        this.channelNumber = 102
        this.websocket = null

        
        if (this.debug) {
            this.setupDebug()
        }
        this.startWebsockets()
    }

    /* Add a handler to a channel */
    handler(channel, callback){
        /* Test channel validity */
        if (! this.isChannelValid(channel)) {
            throw 'Channel '+channel+' is not valid'
        }

        /* Initialize handler array if needed */
        if (!(channel in this.channelHandlers)) {
            this.channelHandlers[channel] = []
        }

        /* Add the handler */
        this.channelHandlers[channel].push(callback)
    }

    /* Test if the channel number is supported */
    isChannelValid (channel) {
        if (channel < 0) {
            return false
        }
        if (channel >= this.channelNumber) {
            return false
        }
        return true
    }


    /* Create websocket connection */
    startWebsockets(){
        window.WebSocket = window.WebSocket || window.MozWebSocket
        this.websocket = new WebSocket(this.host+':'+this.port, 'oma-protocol');
        this.websocket.onopen = () => {
            console.log('websocket opened')
            if (this.debug){
                document.getElementById('oma-debug-connected').textContent = 'Connected!'
                document.getElementById('oma-debug-connected').style = 'color:green;'
            }
            setInterval(()=>{
                this.websocket.send('ping 0')
            }, 60000)

        }
        this.websocket.onerror = () => {
            console.log('websocket error')
            if (this.debug){
                document.getElementById('oma-debug-connected').textContent = 'Websocket error ! See the console.'
                document.getElementById('oma-debug-connected').style = 'color:red;'
            }
            // TODO retry !
        }
        this.websocket.onmessage = (message) => {
            this._log.debug('oma-lib.ws : websocket message : '+message.data)
            if (message.data == ''){return}
            var data = JSON.parse(message.data)

            /* Pass to the handlers if defined */
            for (var channel in data) {
                var channelNum = channel.slice(2) /* On récupère un chaine genre ch4 */
                if (channelNum in this.channelHandlers) {
                    for (var handler in this.channelHandlers[channelNum]) {
                        this.channelHandlers[channelNum][handler](data[channel])
                    }
                }
            }
            /* Interractive format */
            if ('ch' in data) {
                    var channelNum = data['ch']
                    for (var handler in this.channelHandlers[channelNum]) {
                        this.channelHandlers[channelNum][handler](data)
                    }
            }

            /* Pass to debug if debug mode is on */
            if (this.debug){ 
                this.debugChannels(data)
            }
        }
        this.websocket.onclose = (event) => {
            console.log('websocket closed')
            if (this.debug){
                document.getElementById('oma-debug-connected').textContent = 'Disconnected!'
                document.getElementById('oma-debug-connected').style = 'color:red;'
            }
        }
    }


    /* This function is used to send data to the server */
    send(data){
        this._log.debug('sending: ' + data)
        this.websocket.send(data)
    }
}

class OmaEvents {
    constructor () {
        this.events = {}
    }

    register (eventName) {
        this.events[eventName] = []
    }

    on (eventName, callback) {
        this.events[eventName].push(callback)
    }

    trigger (eventName, data=null) {
        if (! eventName in this.events) {
            throw 'Event "' + eventName + '" fired but not registrated'
        }
        for (var i in this.events[eventName]) {
            this.events[eventName][i](data)
        }
    }
    //TODO unregister event
}


export class OmaFiche {
    constructor (content) {
        this.data = {}
        this.parse(content)
    }

    parse (content) {
        var lines = content.split('\n')
        for(var i = 0;i < lines.length;i++){
            var line = lines[i].split('=')
            var key = line[0]
            var value = lines[i].slice(key.length+1)
            this.data[key] = value
        }
    }

    get (key) {
        return this.data[key]
    }
}


function omaGet (url, callback){
    var request = new XMLHttpRequest()
    request.addEventListener("load", () => {
        if (request.status === 200){
            callback(request.responseText)
        } else {
            console.log('Request failed on "'+url+'" result : "'+request.status+'"')
            console.log(request)
        }
    })
    request.open('GET', url)
    request.send()
}


/*
 * This Class is a sound player with no interface.
 * It implements the singleton pattern so there is only one player on a page.
 * Algorithm :
 * When a stream is started, the next is added and its loading is scheduled 15s before the end of this one.
 * If the user move in the stream, the loading date is computed again (how do we cancel the previus ?)
 * 15s before the stream end, the next starts loading
 * On the stream end, the next starts
 * And it starts again.
 */
export class OmaPlayer{
    constructor(radioHost, omaWebsocket, ssl=true){
        /* Singleton */
        var _instance = this.constructor._instance;
        if (_instance)
            return _instance;
        this.constructor._instance = this;

        this._log = new Logger('OmaPlayer', 'error')

        this.events = new OmaEvents()
        this.events.register('muteChange')
        this.events.register('volumeChange')
        this.events.register('timeChange')
        this.events.register('durationChange')
        this.events.register('stateChange')
        this.events.register('typeChange')

        if (typeof(ssl) == 'string') { /* string to boolean */
            this.ssl = (ssl === 'true')
        } else {
            this.ssl = ssl
        }
        this._radioHost = (this.ssl ? 'https://' : 'http://') + radioHost

        /* State and its callback are used to create a pertinent UI */
        this._states = ['loading', 'playing', 'paused', 'idle']

        /* Type */
        this._types = ['idle', 'direct', 'replay', 'podcast']

        /* The oma websocket object */
        this._ows = omaWebsocket
        if (this._ows) {
            this._ows.handler('100', (data) => {this.got_new(data)})
        }

        this.reinit()
    }

    reinit () {
        /* Actual Constructor */
        this._current_stream = null /* The stream that is beeing played */
        this._loading_stream = null /* The next stream, pre-loading */
        this._nextPigeReplayTimeout = null /* Timer returned by setInterval */
        this.currentTime = null
        this._need_to_play = null   /* The date that user asked to play */
        this._volume = 1      /* Sound volume */
        this._mute = false
        this._paused = false

        this._setState('idle')
        this._setType('idle')
    }

    /* Change the state of the player */
    _setState (state) {
        if (! state in this._states) {
            throw 'State "' + state + '" is not valid'
        }
        this._state = state
        this.events.trigger('stateChange', state)
    }

    /* Change the play type */
    _setType (type) {
        if (! type in this._types) {
            throw 'Type "' + type + '" is not valid'
        }
        this._type = type
        this.events.trigger('typeChange', type)
    }

    getState () {
        return this._state
    }
    getType () {
        return this._type
    }

    setVolume(volume) {
        if (volume < 0 || volume > 1 || isNaN(volume)) {
            throw 'Volume "'+volume+'" is not between 0 and 1'
        }
        this._volume = volume
        if (this._current_stream !== null) {
            this._current_stream.player.volume = volume
        }
        this.events.trigger('volumeChange', volume)
    }
    getVolume () {
        return this._volume
    }

    isMute () {
        return this._mute
    }

    mute () {
        if (this._current_stream !== null) {
            this._current_stream.player.muted = true
        }
        this._mute = true
        this.events.trigger('muteChange', 'mute')
    }

    unmute () {
        if (this._current_stream !== null) {
            this._current_stream.player.muted = false
        }
        this._mute = false
        this.events.trigger('muteChange', 'unmute')
    }

    muteUnmute () {
        if (this.isMute()) {
            this.unmute()
        } else {
            this.mute()
        }
    }

    playDirect() {
        this.reinit()
        this._setType('direct')
        this._setState('loading')
        this.events.trigger('timeChange', '')

        var isPaused = false
        if (this._current_stream !== null){
            this._current_stream.player.pause()
        }
        this._loading_stream = null
        this._log.log('playDirect', 'debug') 
        var stream = document.createElement('audio')

        var sourceOgg  = document.createElement('source')
        sourceOgg.src  = this._radioHost+'/direct.ogg'
        sourceOgg.type = 'audio/ogg'
        stream.appendChild(sourceOgg)

        var sourceMp3  = document.createElement('source')
        sourceMp3.src  = this._radioHost+'/direct.mp3'
        sourceMp3.type = 'audio/mpeg'
        stream.appendChild(sourceMp3)

        stream.muted = this._mute
        stream.volume = this._volume
        var _this = this
        stream.play().then(()=>{
            /* Cleaning replay */
            this._current_stream = {'player': stream}
            this._setState('playing')
        })
        stream.onended = () => { /* direct was interrupted ! */
           _this.playDirect() 
        }

    }


    /* Triggered on stream end */
    _stream_end(){
        this._log.log('_stream_end():', 'debug') 
        /* An other stream may have ended? */
        if (!this._current_stream.ended)
            return;
        this.start_stream()
    }


    _start_current_stream(fromStart=false){
        this._log.log('_start_current_stream():', 'debug') 
        if (this._current_stream == null) { return false }
        var player = this._current_stream.player
        player.volume = this._volume
        player.mute = this._mute
        if (fromStart) {
            player.play().then(() => {
                this._setState('playing')
            })
            return true
        }
        this._current_stream._need_to_play = this._need_to_play
        /* Is this the stream we are waiting for? */
        if (this._need_to_play >= this._current_stream.C && (this._need_to_play <= this._current_stream.N || this._current_stream.N === '0')){
            var currentTime = this._need_to_play - this._current_stream.C
            this._log.log('starting current stream at '+currentTime + ' seconds on '+player.duration)
            player.currentTime = currentTime
            player.play().then(() => {
                this._need_to_play = null
                this._setState('playing')
            })
            this._check_for_next()
            return true
        }
        return false
    }


    /* The user input : play/pause */
    play_pause(){
        this._log.log('play_pause():', 'debug') 
        /* No stream exists, no date have been set */
        if (this._state == 'idle') {
            this.playDirect()
            return true
        }
        if(this._current_stream === null)
            return false

        var stream = this._current_stream.player
        if (stream.paused) {
            stream.play()
            this._paused = false
            this._setState('playing')
        } else {
            stream.pause()
            this._paused = true
            this._setState('paused')
        }
        return true
    }

    /* User input : set date. Date is a unix timestamp*/
    set_date(date){
        if (typeof(date) != 'number'){
            this._log.log('set_date(): invalid timestamp', 'warning')
            return
        }
        this._log.log('set_date():', 'debug') 
        this._setType('replay')
        this._setState('loading')
        this._need_to_play = date
        console.log(this._need_to_play)
        this.currentTime = date
        if (this._current_stream !== null)
            this._current_stream.player.pause()
        if (!this._start_current_stream()) { /* look for the time */
            this._current_stream = this._loading_stream
            this._loading_stream = null
            if (!this._start_current_stream()) {
                this._current_stream = null
                if (this._ows)
                    this._ows.send('audioReplaySync ' + date)
            }
        }
        this._initTxtReplay(date)
    }

    set_date_human(date, time){
        if (date == '' || time == ''){
            this._log.log('set_date_human(): empty date or time', 'warning')
            return
        }
        this._log.log('set_date_human():', 'debug') 
        var replay_timestamp = (new OmaDateTime()).fromHtmlDateTime(date, time).toTimestamp()
        if (!replay_timestamp) {this._log.log('error timestamp invalid');return}
        this.set_date(replay_timestamp)
    }

    _initTxtReplay (date) {
        //TODO
        this._log.log('_initTxtReplay():', 'debug') 
        var _this = this
        this._ows.handler(101, (data) => {
            _this._getNextTxtPige(_this, data)
        })
        this._ows.send('txtReplaySync ' + date)
    }

    /* data is the text event */
    _getNextTxtPige (_this, data) {
        var now = _this.getCurrentPlayDate()
        _this._log.debug('_getNextTxtPige(): at '+now+' in '+_this._state) 
        console.log(data)
        if (isNaN(now)) {
            setTimeout(() => {_this._getNextTxtPige(_this, data)}, 1000)
            return
        }
        if (data.status != 'Ok') { _this._log.error('Error getting text replay') ; return }
        if (_this._type != 'replay') { return }
        if (Math.abs(now - data.C) < 2) { /* Time to show message is close */
            _this._ows.send('txtReplayInfo ' + parseInt(data.pos))
            _this._ows.send('txtReplayGet ' + (parseInt(data.pos)+1))
        } else if (now > data.C) {
            /* We skipped the event… No need to display it anymore */
            _this._ows.send('txtReplayGet ' + (parseInt(data.pos)+1)) // TODO mesure how late we are, we may need to sync again.
        } else if (Math.abs(now - data.P) >= 2) {
            /* User got way too far in the past */
        } else { /* Not yet to display */
            console.log('retry in ' + (data.C - now -1)*1000)
            setTimeout(() => { _this._getNextTxtPige(_this, data) }, (data.C - now - 1)*1000)
        }
    }

    _on_end(thisReplacement){
        var _this = thisReplacement ? thisReplacement : this
        _this._setState('loading')
        _this._log.log('_on_end():', 'debug') 
        if (this._current_stream === null ) { return }
        if (_this._loading_stream === null)
            throw "Next stream was not found!"
        _this._current_stream = _this._loading_stream
        _this._loading_stream = null
        _this._current_stream.player.currentTime = 0
        _this._start_current_stream(true)
    }

    forward (amount) {
        var seconds = this.getCurrentPlayDate() + Number(amount)
        if (seconds === null) return;
        this.set_date(seconds)
    }

    getCurrentPlayDate () {
        if (!this._current_stream || this._type === 'direct') { /* If not playing or direct */
            return Math.floor(Date.now() / 1000)
        } else {
            if (this._need_to_play) /* If we are in a hole */
                return this._need_to_play
            else
                return this._current_stream.player.currentTime + parseInt(this._current_stream.C)
        }
    }



    /* Callback for channel 100 */
    got_new (data) {
        this._log.log('got_new():', 'debug') 
        if ('status' in data && data.status != 'Ok') {
            this._log.log('Error in request', 'error')
            //TODO correct error.
            return;
        }

        /* Create the player */
        data.player = document.createElement('audio')

        /* Set ressource link */
        var filename = (new OmaDateTime(Number(data.C))).toPacDateTime() + '.ogg'
        data.player.setAttribute('type', "audio/ogg")
        data.player.setAttribute('src', this._radioHost+'/pige/'+filename)

        /* Start stream loading */
        data.player.load()
        data.player.onloadend = () => {
            this._setState('replay')
        }

        /* Be notified on streams end */
        var _this = this
        data.player.onended = () => { _this._on_end(_this) }
        data.player.ontimeupdate = () => {_this.timeUpdate(_this) }

        if (this._need_to_play !== null){
            /* Test if the server have the file */
            if (!( parseInt(data.C) <= this._need_to_play
                && (parseInt(data.N) == 0  || parseInt(data.N) > this._need_to_play) )) {
                //TODO go for next stream ? Nah ?
                console.log('We did not get the stream we expected')
                return
            }
            this._log.log('set _current_stream', 'debug')
            this._current_stream = data
            this._start_current_stream()
        } else { /* Just pre-loading */
            this._loading_stream = data
            this._log.log('set _loading_stream', 'debug')
        }
    }

    timeUpdate (thisReplacement) {
        var _this = thisReplacement ? thisReplacement : this
        if (!_this._current_stream) return;
        _this.currentTime = Math.floor(parseInt(_this._current_stream.C) + _this._current_stream.player.currentTime)
        _this.events.trigger('timeChange', _this.currentTime)
    }

    _check_for_next(){
        this._log.log('_check_for_next():', 'debug') 
        if (! this._current_stream) { return }
        var need = this._need_to_play ? this._need_to_play : this._current_stream._need_to_play;
        /* If we don’t know the stream duration, we come back in 2 secs */
        if (isNaN(this._current_stream.player.duration))
            window.setTimeout(()=>{this._check_for_next()}, 2000)
        /* Test if the server have the file */
        else if (!( this._current_stream.C <= need
            && (this._current_stream.N == 0 || this._current_stream.N > need)
            && parseInt(this._current_stream.C) + this._current_stream.player.duration >= need
        )) {
            alert('Le replay que vous avez demandé n’est pas disponible… Désolé !')
            this.reinit()
            return
        }
        /* If the stream is one minute of the end, we get the next from internet */
        else if (this._current_stream.player.duration - this._current_stream.player.currentTime < 60)
            this._ows.send('audioReplayGet ' + (Number(this._current_stream.pos) + 1))
        /* if the stream is more than a minute from the end, we come back later */
        else
            window.setTimeout(()=>{this._check_for_next()}, (this._current_stream.player.duration - this._current_stream.player.currentTime - 50)*1000)
    }
}

function dnsLookup(name=null, callback=null, type='A') {
    // TODO use our own DOH server for security
    if (name === null || callback === null) {
        throw 'parameters are null or not found for DNS query'
    }

    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            callback(this.responseText)
        } else if (this.status) {
            //throw 'Error in DNS lookup  "' + this.status + '" ' + this.readyState + ' : ' + this.responseText
        }
    };

    /* Should work with both */

    /* https://developers.cloudflare.com/1.1.1.1/dns-over-https/json-format */
    //xhttp.open("GET", "https://cloudflare-dns.com/dns-query?name="+name+'&type='+type)
    
    /* https://www.quad9.net/doh-quad9-dns-servers */
    xhttp.open("GET", "https://9.9.9.9:5053/dns-query?name="+name+'&type='+type)

    xhttp.setRequestHeader('accept', 'application/dns-json');
    xhttp.send()
}

function setReplayFor (t, anchor=null) {
    var player = new OmaPlayer()
    return () => {
        player.set_date(t)
        if (anchor) jump(anchor)
        }
}


function omaReplayList (div) {
    omaGet('./replays.json', (data) => {
        var categories = JSON.parse(data)
        var ul = document.createElement('ul')
        div.appendChild(ul)
        for (var icat in categories) {
            var cat = categories[icat]
            var title = document.createElement('h4')
            title.innerText = cat.title
            ul.appendChild(title) 
            for (var ireplay in cat.replays) {
                var replay = cat.replays[ireplay]
                var li = document.createElement('li')
                li.style = "cursor: pointer;"
                ul.appendChild(li)
                li.innerText = replay.title + ' par ' + ('author' in replay ? replay.author : cat.author)
                li.onclick = setReplayFor(replay.begin, 'listen') //TODO get this item from config
                //todo onclick
            }
        }
    })
}

export class OmaConfig {
    constructor (){
        /* Singleton */
        const instance = this.constructor.instance;
        if (instance) { return instance }
        this.constructor.instance = this;

        this.config = null

        /* null means mandatory */
        this._defaultConf = {
            'radioname': '',
            'wsport': null,
            'wsdebug': false,
            'wsdebugtag': '',
            'playerdebug': false,
            'replayerdebug': false,
            'radiohost': null,
            'ssl': true,
            'clean-name': null,
        }
        this._fetchConfig()
    }

    get (key) {
        var k = key.toLowerCase()
        if (! k in this._defaultConf) { return undefined }
        return this._defaultConf[k]
    }

    _fetchConfig () {
        var configTag = document.getElementById('omaRadio-config')
        if (configTag == null) {
            throw 'No config found for oma-radio player'
        }
        var configAttributes = configTag.attributes
        this.config = this._defaultConf
        for (var confElement in this.config) {
            if (confElement in configAttributes) {
                this.config[confElement] = configAttributes[confElement].value
            }
        }
    }
}

